import { createContext } from "react";
import ReactPlayer from "react-player";
import TimelinePositions from "../types/TimelinePositions";
import TimelineItem from "types/TimelineItem";

export interface TimelinePlayerContextValues {
  // Values
  absoluteTime: number;
  comment: string | undefined;
  endTime: number | undefined;
  currentTimelineItem: TimelineItem | undefined;
  isBeingModified: boolean;
  isScrubbing: boolean;
  fullscreen: boolean;
  playbackRate: number;
  player: ReactPlayer | undefined;
  playing: boolean;
  seekToAbsolutePosition: number | undefined;
  seekToAfterPlayerInit: number | undefined;
  seekToRelativePosition: number | undefined;
  startTime: number | undefined;
  timelineItemId: string | undefined;
  timelineItemIndex: number;
  timelinePositions: TimelinePositions;
  totalDuration: number;
  videoId: string | undefined;

  setAbsoluteTime: (time: number) => void;
  setComment: (comment: string | undefined) => void;
  setCurrentTimelineItem: (timelineItem: TimelineItem | undefined) => void;
  setEndTime: (time: number | undefined) => void;
  setFullscreen: (fullScreen: boolean) => void;
  setIsBeingModified: (isBeingModified: boolean) => void;
  setIsScrubbing: (isScrubbing: boolean) => void;
  setPlaybackRate: (playbackRate: number) => void;
  setPlayer: (player: ReactPlayer | undefined) => void;
  setPlaying: (playing: boolean) => void;
  setSeekToAbsolutePosition: (time: number | undefined) => void;
  setSeekToAfterPlayerInit: (time: number | undefined) => void;
  setSeekToRelativePosition: (time: number | undefined) => void;
  setStartTime: (time: number | undefined) => void;
  setTimelineItemId: (id: string | undefined) => void;
  setTimelineItemIndex: (index: number) => void;
  setTimelinePositions: (timelinePositions: TimelinePositions) => void;
  setTotalDuration: (duration: number) => void;
  setVideoId: (videoId: string | undefined) => void;
}

const TimelinePlayerContext = createContext<TimelinePlayerContextValues>({
  absoluteTime: 0,
  comment: undefined,
  currentTimelineItem: undefined,
  endTime: undefined,
  fullscreen: false,
  isBeingModified: false,
  isScrubbing: false,
  playbackRate: 1,
  player: undefined,
  playing: false,
  seekToAbsolutePosition: undefined,
  seekToAfterPlayerInit: undefined,
  seekToRelativePosition: undefined,
  startTime: undefined,
  timelineItemId: undefined,
  timelineItemIndex: 0,
  timelinePositions: new Map(),
  totalDuration: 0,
  videoId: undefined,

  setAbsoluteTime: () => {
    /* placeholder */
  },
  setComment: () => {
    /* placeholder */
  },
  setCurrentTimelineItem: () => {
    /* placeholder */
  },
  setEndTime: () => {
    /* placeholder */
  },
  setFullscreen: () => {
    /* placeholder */
  },
  setIsBeingModified: () => {
    /* placeholder */
  },
  setIsScrubbing: () => {
    /* placeholder */
  },
  setPlaybackRate: () => {
    /* placeholder */
  },
  setPlayer: () => {
    /* placeholder */
  },
  setPlaying: () => {
    /* placeholder */
  },
  setSeekToAbsolutePosition: () => {
    /* placeholder */
  },
  setSeekToAfterPlayerInit: () => {
    /* placeholder */
  },
  setSeekToRelativePosition: () => {
    /* placeholder */
  },
  setStartTime: () => {
    /* placeholder */
  },
  setTimelineItemId: () => {
    /* placeholder */
  },
  setTimelineItemIndex: () => {
    /* placeholder */
  },
  setTimelinePositions: () => {
    /* placeholder */
  },
  setTotalDuration: () => {
    /* placeholder */
  },
  setVideoId: () => {
    /* placeholder */
  },
});
TimelinePlayerContext.displayName = "TimelinePlayerContext";

export default TimelinePlayerContext;
